<div
  class="attribute-editor-component layout-ems-container"
  *ngIf="!calendarType"
>
  <!-- SELECT PROVIDER SECTION -->
  <div class="attribute-editor-row">
    <h3 class="top-heading">Connect your calendar</h3>
  </div>
  <div class="attribute-editor-row">
    <div class="source-container form-group">
      <label>Connect a calendar to display events and room bookings.</label>
      @if (authenticateFailed) {
        <div class="form-group has-error">
          <p class="help-block">
            <span
              >There was an issue with authentication. Please try again.</span
            >
          </p>
        </div>
      }
      <button
        matButton="outlined"
        class="tw-w-full tw-mb-2.5 button-role--provider"
        type="button"
        (click)="selectCalendarType(PROVIDER_ADASTRA)"
      >
        <mat-icon svgIcon="integration-ad-astra" aria-hidden="true"></mat-icon>
        <span>Continue with Ad Astra</span>
      </button>

      <button
        matButton="outlined"
        class="tw-w-full tw-mb-2.5 button-role--provider"
        type="button"
        (click)="selectCalendarType(PROVIDER_GOOGLE_CALENDAR)"
      >
        <mat-icon svgIcon="integration-google" aria-hidden="true"></mat-icon>
        <span>Continue with Google</span>
      </button>

      <button
        matButton="outlined"
        class="tw-w-full tw-mb-2.5 button-role--provider"
        type="button"
        (click)="selectCalendarType(PROVIDER_OUTLOOK_CALENDAR)"
      >
        <mat-icon svgIcon="integration-microsoft" aria-hidden="true"></mat-icon>
        <span>Continue with Microsoft</span>
      </button>

      <rv-divider label="or" />

      <button
        matButton="outlined"
        class="tw-w-full button-role--provider"
        id="te-layout-calendar-enter-url"
        type="button"
        (click)="selectCalendarType(CALENDAR_TYPE_PUBLIC)"
      >
        <mat-icon svgIcon="link" aria-hidden="true"></mat-icon>
        <span>Enter Public URL</span>
      </button>
    </div>
  </div>
</div>

<!-- SETTINGS SECTION -->
<div
  class="attribute-editor-component layout-ems-container"
  *ngIf="calendarType"
  rvSpinner="layout-ems-loader"
  [rvShowSpinner]="spinner"
>
  <mat-menu
    #connectionOptions="matMenu"
    xPosition="before"
    role="menu"
    tabindex="-1"
  >
    <button
      type="button"
      class="playlist-item-hide"
      tabindex="-1"
      mat-menu-item
      role="menuitem"
      (click)="switchSource()"
    >
      <mat-icon
        svgIcon="switch"
        class="mr-3 small thin"
        aria-hidden="true"
      ></mat-icon>
      <span>Switch Calendar Source</span>
    </button>
    @if (canDisconnect()) {
      <rv-divider class="tw-my-[8px]" />
      <button
        type="button"
        class="playlist-item-hide"
        tabindex="-1"
        mat-menu-item
        role="menuitem"
        (click)="confirmDisconnect()"
      >
        <mat-icon
          svgIcon="unlink"
          class="mr-3 small"
          aria-hidden="true"
        ></mat-icon>
        <span>Disconnect Account</span>
      </button>
    }
    @if (provider === PROVIDER_ADASTRA) {
      <rv-divider class="tw-my-[8px]" />
      <button
        type="button"
        class="playlist-item-hide"
        tabindex="-1"
        mat-menu-item
        role="menuitem"
        (click)="openIntegrationsPage($event)"
      >
        <mat-icon
          svgIcon="integrations"
          class="mr-3 small thin"
          aria-hidden="true"
        ></mat-icon>
        <span>Manage Integration</span>
      </button>
    }
  </mat-menu>

  @if (authenticateFailed) {
    <div class="attribute-editor-row">
      <div class="form-group has-error">
        <p class="help-block">
          <span>There was an issue with authentication. Please try again.</span>
        </p>
      </div>
    </div>
  }

  @if (providerCredentialsMissing) {
    <div class="attribute-editor-row">
      <div class="form-group has-error">
        <p class="help-block">
          <span
            >Credentials for {{ getProviderName(provider) }} are missing. Visit
            <a actionLink (click)="openIntegrationsPage($event)"
              >Integrations</a
            >
            page to connect your account.</span
          >
        </p>
      </div>
    </div>
  }

  @if (revokeFailed) {
    <div class="attribute-editor-row">
      <div class="form-group has-error">
        <p class="help-block">
          We could not revoke your access with
          {{ getProviderName(revokeFailedProvider) }} at this time. We strongly
          recommend you manually revoke access in your
          {{ getProviderName(revokeFailedProvider) }} account.
        </p>
      </div>
    </div>
  }

  <!-- Account Information -->
  @if (USER_AUTHORIZED_PROVIDERS.includes(provider) && componentAccount) {
    <div class="attribute-editor-row tw-mb-[15px]">
      <div class="flex-row flex-wrap space-between mb-3">
        <label>Connected Account</label>
      </div>

      <div class="authenticated button-with-options-menu">
        <mat-icon
          [svgIcon]="getProviderLogo(provider)"
          aria-hidden="true"
        ></mat-icon>

        <div class="mx-auto u_ellipsis">
          {{ componentAccountUsername || 'account not connected' }}
        </div>

        <button
          class="btn btn-icon"
          aria-label="Options menu"
          type="button"
          [matMenuTriggerFor]="connectionOptions"
        >
          <mat-icon
            svgIcon="more-vertical"
            class="tw-rotate-90"
            aria-hidden="true"
          ></mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Account Information / Ad Astra -->
  @if (provider === PROVIDER_ADASTRA) {
    <div class="attribute-editor-row tw-mb-[15px]">
      <div class="authenticated">
        @if (provider === PROVIDER_ADASTRA) {
          <mat-icon
            svgIcon="integration-ad-astra"
            aria-hidden="true"
          ></mat-icon>
        }

        <div class="mx-auto u_ellipsis">
          {{ getProviderName(provider) }}
        </div>

        <button
          class="btn btn-icon"
          aria-label="Options menu"
          type="button"
          [matMenuTriggerFor]="connectionOptions"
        >
          <mat-icon
            svgIcon="more-vertical"
            class="tw-rotate-90"
            aria-hidden="true"
          ></mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Calendar Selection / User A-->
  @if (
    SINGLE_ROOM_PROVIDERS.includes(provider) &&
    sameAccount &&
    componentAccountUsername
  ) {
    @if (provider === PROVIDER_OUTLOOK_CALENDAR) {
      <div class="attribute-editor-row">
        <div
          class="form-group has-feedback"
          [ngClass]="{ 'has-error': outlookGroupsFailed }"
        >
          <label>Calendar Group</label>
          <select
            class="form-control"
            id="te-outlook-group-id"
            name="te-outlook-group-id"
            [(ngModel)]="selectedOutlookGroup"
            (ngModelChange)="selectedOutlookGroupChanged()"
          >
            <option value="" [shown]="false">Select Group</option>
            @for (g of outlookGroups; track g.id) {
              <option [value]="g.id">{{ g.name }}</option>
            }
          </select>
          @if (outlookGroupsFailed) {
            <p class="help-block">
              <span
                >We couldn't load your Outlook calendar groups. Try again. If
                the issue continues, contact support.</span
              >
            </p>
          }
        </div>
      </div>
    }
    <div class="attribute-editor-row">
      <div
        class="form-group has-feedback"
        [ngClass]="{ 'has-error': calendarsFailed }"
      >
        <label>Calendar</label>
        <select
          class="form-control"
          id="te-calendar-id"
          name="te-calendar-id"
          [(ngModel)]="selectedCalendar"
          (ngModelChange)="selectedCalendarChanged()"
        >
          <option value="" [shown]="false">Select Calendar</option>
          @for (c of calendars; track c.id) {
            <option [value]="c.id">{{ c.name }}</option>
          }
        </select>
        @if (calendarsFailed) {
          <p class="help-block">
            <span
              >We couldn't load your calendars. Try again. If the issue
              continues, contact support.</span
            >
          </p>
        }
      </div>
    </div>
  }

  <!-- Calendar Selection / User B-->

  @if (
    SINGLE_ROOM_PROVIDERS.includes(provider) &&
    (!sameAccount || !componentAccountUsername) &&
    !isPublicUrl()
  ) {
    @if (provider === PROVIDER_OUTLOOK_CALENDAR) {
      <div class="attribute-editor-row">
        <div class="form-group has-feedback">
          <label>Calendar Group</label><br />
          {{ selectedOutlookGroupName ? selectedOutlookGroupName : '' }}
        </div>
      </div>
    }

    <div class="attribute-editor-row">
      <div class="form-group has-feedback">
        <label>Calendar</label><br />
        {{ selectedName ? selectedName : '' }}
      </div>
    </div>
  }

  @if (isPublicUrl()) {
    <div class="attribute-editor-row">
      <form>
        <div
          class="form-group has-feedback"
          [ngClass]="{
            'has-error': calendarUrlStatus && calendarUrlStatus !== 'VALID',
            'has-success': calendarUrlStatus && calendarUrlStatus === 'VALID',
          }"
        >
          <label for="te-ems-calendar-url">Calendar URL</label>
          <div class="input-with-button-wrapper">
            <input
              type="text"
              id="te-ems-calendar-url"
              name="te-ems-calendar-url"
              class="form-control u_ellipsis"
              placeholder="iCal link or public URL"
              [(ngModel)]="source"
              (debounceEvent)="saveCalendarUrl()"
              aria-label="Calendar URL"
              maxlength="2048"
              [attr.aria-invalid]="
                calendarUrlStatus && calendarUrlStatus !== 'VALID'
              "
            />
            <streamline-icon
              *ngIf="calendarUrlStatus"
              class="overlay-icon form-control-feedback"
              aria-hidden="true"
              [name]="
                calendarUrlStatus !== 'VALID' ? 'exclamation' : 'checkmark'
              "
              width="14"
              height="12"
            ></streamline-icon>
            <button
              class="btn btn-icon"
              aria-label="Options menu"
              type="button"
              [matMenuTriggerFor]="connectionOptions"
              *ngIf="!componentAccount"
            >
              <mat-icon
                svgIcon="more-vertical"
                class="tw-rotate-90"
                aria-hidden="true"
              ></mat-icon>
            </button>
          </div>

          <p class="help-block">
            @if (calendarUrlStatus === 'INVALID') {
              <span
                >This calendar is invalid or not publicly accessible. To fix the
                issue, see
                <a
                  href="https://help.risevision.com/hc/en-us/articles/48407811260948-Show-a-Google-or-Microsoft-Calendar"
                  target="_blank"
                  rel="noopener noreferrer"
                  >this article</a
                >.</span
              >
            }
          </p>
        </div>
      </form>
    </div>
  }

  <!-- Filter by Display Room toggle -->
  <div class="attribute-editor-row" *ngIf="!isSingleRoomProvider()">
    <div class="flex-row left-right-aligner pt-3">
      <label id="ems-filter-by-room-label" class="mb-0 control-label"
        >Filter by Display Room</label
      >
      <mat-slide-toggle
        class="pl-3"
        [checked]="filterByRoom"
        (change)="filterByRoomChanged($event.checked)"
        [attr.aria-labelledby]="'ems-filter-by-room-label'"
      ></mat-slide-toggle>
    </div>
    <p class="help-block" style="margin-top: 8px">
      When enabled, each display shows events only for its assigned room.
    </p>
  </div>

  <!-- Layout Selection -->
  <div
    class="attribute-editor-row"
    *ngIf="filterByRoom || isSingleRoomProvider()"
  >
    <label *ngIf="isSingleRoomProvider()">Layout</label>
    <div class="form-group layout-selector">
      <div
        class="layout-container"
        role="radiogroup"
        aria-label="Layout selection"
      >
        <button
          type="button"
          class="layout-option layout-option--selected"
          *ngIf="isCustomLayout"
          aria-checked="true"
          role="radio"
        >
          <div class="layout-icon-container"></div>
          <div class="layout-label">Custom</div>
        </button>
        <button
          type="button"
          class="layout-option"
          [ngClass]="{
            'layout-option--selected': layout === LayoutType.ROOM_SCHEDULE,
          }"
          (click)="setLayout(LayoutType.ROOM_SCHEDULE)"
          [attr.aria-checked]="layout === LayoutType.ROOM_SCHEDULE"
          role="radio"
        >
          <div class="layout-icon-container">
            <svg
              width="74"
              height="65"
              viewBox="0 0 74 65"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="73.1196"
                width="12.3931"
                height="73.1195"
                rx="1.23931"
                transform="rotate(90 73.1196 0)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="73.1196"
                y="17.3506"
                width="12.3931"
                height="73.1195"
                rx="1.23931"
                transform="rotate(90 73.1196 17.3506)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="73.1196"
                y="34.7007"
                width="12.3931"
                height="73.1195"
                rx="1.23931"
                transform="rotate(90 73.1196 34.7007)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="37.1797"
                y="2.20312"
                width="2.47863"
                height="34.7008"
                rx="1.23931"
                transform="rotate(90 37.1797 2.20312)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="16.1113"
                y="7.16064"
                width="2.47863"
                height="13.6325"
                rx="1.23931"
                transform="rotate(90 16.1113 7.16064)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="52.0513"
                y="19.5537"
                width="2.47863"
                height="49.5726"
                rx="1.23931"
                transform="rotate(90 52.0513 19.5537)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="21.0688"
                y="24.5107"
                width="2.47863"
                height="18.5897"
                rx="1.23931"
                transform="rotate(90 21.0688 24.5107)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="21.0688"
                y="36.9038"
                width="2.47863"
                height="18.5897"
                rx="1.23931"
                transform="rotate(90 21.0688 36.9038)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="29.7437"
                y="41.8613"
                width="2.47863"
                height="27.2649"
                rx="1.23931"
                transform="rotate(90 29.7437 41.8613)"
                fill="#020620"
                fill-opacity="0.1"
              />
            </svg>
          </div>
          <div class="layout-label">Room Schedule</div>
        </button>
        <button
          type="button"
          class="layout-option"
          [ngClass]="{
            'layout-option--selected': layout === LayoutType.ROOM_STATUS,
          }"
          (click)="setLayout(LayoutType.ROOM_STATUS)"
          [attr.aria-checked]="layout === LayoutType.ROOM_STATUS"
          role="radio"
        >
          <div class="layout-icon-container">
            <svg
              width="66"
              height="66"
              viewBox="0 0 66 66"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="65.999"
                y="23.2402"
                width="19.5165"
                height="22.4809"
                rx="1"
                transform="rotate(90 65.999 23.2402)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="40.2183"
                y="23.2402"
                width="19.5165"
                height="40.2182"
                rx="1"
                transform="rotate(90 40.2183 23.2402)"
                fill="#020620"
                fill-opacity="0.25"
              />
              <circle cx="34.9995" cy="37.5" r="2.5" fill="#3BBF74" />
              <rect
                x="65.999"
                y="2.88491e-06"
                width="19.5165"
                height="35.9808"
                rx="1"
                transform="rotate(90 65.999 2.88491e-06)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="26.3174"
                y="2.88491e-06"
                width="19.5165"
                height="26.3174"
                rx="1"
                transform="rotate(90 26.3174 2.88491e-06)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="65.999"
                y="46.4834"
                width="19.5165"
                height="27.8434"
                rx="1"
                transform="rotate(90 65.999 46.4834)"
                fill="#020620"
                fill-opacity="0.1"
              />
              <rect
                x="34.856"
                y="46.4834"
                width="19.5165"
                height="34.8558"
                rx="1"
                transform="rotate(90 34.856 46.4834)"
                fill="#020620"
                fill-opacity="0.1"
              />
            </svg>
          </div>
          <div class="layout-label">Room Status</div>
        </button>
      </div>
    </div>
  </div>

  <div class="attribute-editor-row">
    <label>Date Range</label>
    <div
      class="has-feedback"
      [ngClass]="{
        'has-error': !isValidRange(),
        'has-success': isValidRange() && range,
      }"
    >
      <div class="flex-row">
        <input
          type="number"
          class="form-control mr-2"
          id="te-calendar-range"
          name="te-calendar-range"
          placeholder="Range"
          [(ngModel)]="range"
          [min]="rangeMin"
          [max]="rangeMax"
          (ngModelChange)="rangeChanged()"
          aria-label="Date range value"
        />
        <select
          class="form-control"
          id="te-calendar-period"
          name="te-calendar-period"
          [(ngModel)]="period"
          (ngModelChange)="periodChanged()"
          aria-label="Date range period"
        >
          <option value="days">Days</option>
          <option value="weeks">Weeks</option>
          <option value="months">Months</option>
        </select>
      </div>
      @if (!isValidRange()) {
        <p class="help-block">
          <span
            >Please provide a number between {{ rangeMin }} and
            {{ rangeMax }}.</span
          >
        </p>
      }
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="flex-row left-right-aligner pt-3 form-group">
      <label id="ems-show-description-label" class="mb-0 control-label"
        >Show Description</label
      >
      <mat-slide-toggle
        class="pl-3"
        [checked]="showDescription"
        (change)="showDescription = $event.checked; save()"
        [attr.aria-labelledby]="'ems-show-description-label'"
      ></mat-slide-toggle>
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="flex-row left-right-aligner pt-3">
      <label id="ems-show-completed-label" class="mb-0 control-label"
        >Show Completed Events</label
      >
      <mat-slide-toggle
        class="pl-3"
        [checked]="showCompleted"
        (change)="showCompleted = $event.checked; save()"
        [attr.aria-labelledby]="'ems-show-completed-label'"
      ></mat-slide-toggle>
    </div>
  </div>

  <div class="attribute-editor-row tw-mt-5">
    <div class="form-group">
      <label for="te-ems-color">Color</label>
      <div class="flex-row left-right-aligner">
        <color-picker
          pickerId="te-ems-color"
          [(ngModel)]="color"
          (change)="save()"
          ngDefaultControl
        ></color-picker>
      </div>
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="form-group">
      <label for="te-ems-bg-color">Background</label>
      <div class="flex-row left-right-aligner">
        <color-picker
          pickerId="te-ems-bg-color"
          [(ngModel)]="backgroundColor"
          (change)="save()"
          ngDefaultControl
        ></color-picker>
      </div>
    </div>
  </div>
</div>
